import Link, { LinkProps } from 'next/link';
import { ForwardedRef, forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from 'styled-components';

import { TextLink, TextLinkAnchor } from '@src/components/atoms/text-link';
import { useCmsContent } from '@src/contexts/cms-content-context';

import { ContentWithLinkProps, isTextLinkProps } from './types';

const ContentWithLink = forwardRef(
  ({ contentKey, className, ...linkProps }: ContentWithLinkProps, ref?: ForwardedRef<HTMLButtonElement>) => {
    const content = useCmsContent();
    return (
      <span ref={ref} className={className}>
        <FormattedMessage
          id={contentKey}
          defaultMessage={content[contentKey]}
          values={{
            a: (chunks) =>
              isTextLinkProps(linkProps) ? (
                <TextLink {...linkProps}>{chunks}</TextLink>
              ) : (
                <TextLinkAnchor {...(linkProps as LinkProps)} as={Link}>
                  {chunks}
                </TextLinkAnchor>
              ),
          }}
        />
      </span>
    );
  },
);

ContentWithLink.displayName = 'ContentWithLink';

export default styled(ContentWithLink)``;
